/*
====================================================================
            Servicio generarCodigoRestablecimiento
====================================================================
Este servicio maneja la solicitud para generar un código de restablecimiento 
de contraseña. Envía la dirección de correo electrónico del usuario al backend 
para que se envíe un enlace de restablecimiento de contraseña.

- Utiliza el método POST para enviar el correo electrónico.
- El correo electrónico se envía en formato JSON en el cuerpo de la solicitud.
- La URL de la API se configura mediante la variable de entorno `V_URL_API`.

====================================================================
*/

// ------------------------------------------------------------------
//                            IMPORTS
// ------------------------------------------------------------------
// Importación de la configuración necesaria.

import { V_URL_API } from '../../../utils/config';
import RestablecerContraseñaEntity from '../../../core/entities/restablecerContraseñaEntity';

// ------------------------------------------------------------------
//                       DEFINICIÓN DEL SERVICIO
// ------------------------------------------------------------------
/**
 * Envía una solicitud para generar un código de restablecimiento de contraseña.
 * 
 * Este servicio toma un correo electrónico como argumento y lo envía al servidor 
 * mediante una solicitud `POST` para que se genere un enlace de restablecimiento 
 * de contraseña. La respuesta de la API se devuelve como una promesa.
 * 
 * @param {string} correos - El correo electrónico al que se enviará el enlace de restablecimiento.
 * @returns {Promise<Response>} - Una promesa que resuelve la respuesta de la API.
 */
export async function generarCodigoRestablecimiento(correos=new RestablecerContraseñaEntity()) {
    // Realiza la solicitud `POST` a la API para generar el código de restablecimiento
    return await fetch(`${V_URL_API}/api/restablecer_contraseña/generar-codigo`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(correos ),
    });
}
